import { Avatar, ConversationHeader } from '@chatscope/chat-ui-kit-react';
import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Can } from '../../../../context/Ability';
import {
  FullscreenExitOutlined,
  FullscreenOutlined,
  HistoryOutlined,
  PreviewOutlined,
  RestartAltOutlined,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { reset, selectFullScreen, setFullScreen, setPreview, setShowHistory } from '../../giftSlice';
import { useTheme } from '@emotion/react';
import { variants } from '../../../../variants/variants';
import { useLocation, useNavigate } from 'react-router-dom';

const CandidateNavbar = () => {
  const dispatch = useDispatch();
  const fullScreen = useSelector(selectFullScreen);
  const theme = useTheme();
  const { pathname } = useLocation();
  const activePath = pathname.split('/')[3];
  const navigate = useNavigate();
  const value = pathname.split('/gift/')[1]?.split('/')[0];
  const handleFullScreenClick = () => {
    dispatch(setFullScreen({ value: fullScreen ? false : true }));
  };
  const handleResetClick = () => {
    dispatch(reset({}));
  };
  const handleHistoryClick = () => {
    dispatch(setShowHistory({ value }));
    dispatch(setPreview({ reset: true }));
  };
  return (
    <>
      <ConversationHeader
        style={{
          background: '#fff',
          padding: 0,
          border: 0,
        }}
      >
        <Avatar
          className='chatAvatar'
          name='GIFT bot'
          status='available'
          size='md'
          src='https://chatscope.io/storybook/react/assets/emily-xzL8sDL2.svg'
        />
        <ConversationHeader.Content>
          <b>GIFT AI bot</b>
        </ConversationHeader.Content>
      </ConversationHeader>

      {/* for smaller screens */}
      <Stack
        direction={'row'}
        sx={{
          ml: 'auto',
        }}
      >
        <Stack sx={{ mr: 2, cursor: 'default' }} onClick={handleHistoryClick}>
          <IconButton sx={{ m: 'auto', p: 0 }}>
            <HistoryOutlined />
          </IconButton>
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>History</Typography>
        </Stack>
        <Stack sx={{ mr: 1, cursor: 'default' }} onClick={handleResetClick}>
          <IconButton sx={{ m: 'auto', p: 0 }}>
            <RestartAltOutlined />
          </IconButton>
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>Reset</Typography>
        </Stack>
        <Can I='create' a={'GiftForm'}>
          <Tooltip
            title={fullScreen ? 'exit fullscreen' : 'fullscreen'}
            sx={{
              [theme.breakpoints.down('lg')]: { display: 'none' },
            }}
          >
            <IconButton onClick={handleFullScreenClick}>
              {!fullScreen ? <FullscreenOutlined /> : <FullscreenExitOutlined />}
            </IconButton>
          </Tooltip>
        </Can>
      </Stack>

      {/* for larger screens */}
      {/* <Stack direction={'row'} alignItems={'center'} ml={'auto'}>
        <Stack sx={{ mr: 2, cursor: 'default' }} onClick={handleHistoryClick}>
          <IconButton sx={{ m: 'auto', p: 0 }}>
            <HistoryOutlined />
          </IconButton>
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>History</Typography>
        </Stack>
        <Button
          size='small'
          variant='outlined'
          sx={{
            mr: 1,
            ml: 'auto',
            [theme.breakpoints.down('lg')]: { display: 'none' },
          }}
          onClick={handleResetClick}
          endIcon={<RestartAltOutlined />}
        >
          Reset
        </Button>
        <Can I='create' a={'GiftForm'}>
          <Tooltip
            title={fullScreen ? 'exit fullscreen' : 'fullscreen'}
            sx={{
              [theme.breakpoints.down('lg')]: { display: 'none' },
            }}
          >
            <IconButton onClick={handleFullScreenClick}>
              {!fullScreen ? <FullscreenOutlined /> : <FullscreenExitOutlined />}
            </IconButton>
          </Tooltip>
        </Can>
      </Stack> */}
    </>
  );
};

export default CandidateNavbar;
